export default "__VITE_ASSET__Cgr9PlJH__"